<template>
    <div :class="containerClass">
        <background-parallax
            :srcProp="
                $store.getters['user/isOrganization']
                    ? require('@/assets/images/background-images/wbc-banner-clean.jpg')
                    : ''
            "
            :backgroundOpacityProp="'0.4'"
        />
        <v-sheet
            class="mb-6 py-6 box box-rounded box-transparent box-transparent-dark d-none d-md-block"
            elevation="6"
        >
            <h1 class="page-header display-1 font-weight-medium white--text">
                Active Requests<span v-if="$store.getters['user/isOrganization']"> - {{ organizationBranch.branchName }}</span>
            </h1>
        </v-sheet>
        <v-card
            class="box box-rounded box-transparent box-transparent-light"
            elevation="12"
        >
            <v-card-subtitle>
                <v-breadcrumbs class="smc-breadcrumbs">
                    <v-breadcrumbs-item class="smc-breadcrumbs-item" to="/">
                        <v-icon>mdi-home</v-icon>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-divider v-if="!$store.getters['user/isOrganization']">
                        /
                    </v-breadcrumbs-divider>
                    <v-breadcrumbs-item
                        class="smc-breadcrumbs-item"
                        to="/my-garage"
                        v-if="!$store.getters['user/isOrganization']"
                    >
                        My Garage
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
                    <v-breadcrumbs-item class="smc-breadcrumbs-item">
                        Active Requests
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-subtitle>

            <v-card-text :class="$vuetify.breakpoint.smAndDown ? 'px-0' : ''">
                <v-sheet class="active-work-tab-container">
                    <v-tabs
                        v-if="$vuetify.breakpoint.mdAndUp"
                        v-model="currentTab"
                        fixed-tabs
                        center-active
                        centered
                        background-color="primary"
                        active-class="white red--text border"
                        slider-color="transparent"
                        show-arrows
                    >
                        <v-tab :class="!$store.getters['user/isOrganization'] ? 'd-none' : ''">Vehicles</v-tab>
                        <v-tab> Pending </v-tab>
                        <v-tab :class="!$store.getters['user/isWeBuyCars'] ? 'd-none' : ''"> Shared to Nexus </v-tab>
                        <v-tab> Booked / In Progress </v-tab>
                        <v-tab> Ready for Collection </v-tab>
                        <v-tab> Completed </v-tab>
                    </v-tabs>

                    <div class="pa-3 primary" v-else>
                        <v-select
                            v-model="currentTab"
                            :items="tabOptions"
                            rounded
                            color="primary"
                            dense
                            outlined
                            hide-details
                            :menu-props="{ offsetY: true, maxHeight: 300 }"
                            
                        />
                    </div>

                     <!-- Shared content (works for both tabs & dropdown) -->
                    <v-tabs-items v-model="currentTab">
                        <v-tab-item :class="!$store.getters['user/isOrganization'] ? 'd-none' : ''">
                            <my-garage-tab />
                        </v-tab-item>
                        <v-tab-item>
                            <active-request-tab
                                v-if="currentTab === 1"
                                :stageProp="'1'"
                            />
                        </v-tab-item>
                        <v-tab-item>
                            <active-request-tab
                                v-if="currentTab === 2"
                                :stageProp="'2'"
                            />
                        </v-tab-item>
                        <v-tab-item>
                            <active-request-tab
                                v-if="currentTab === 3"
                                :stageProp="'3'"
                            />
                        </v-tab-item>
                        <v-tab-item>
                            <active-request-tab
                                v-if="currentTab === 4"
                                :stageProp="'4'"
                            />
                        </v-tab-item>
                        <v-tab-item>
                            <active-request-tab
                                v-if="currentTab === 5"
                                :stageProp="'5'"
                            />
                        </v-tab-item>
                    </v-tabs-items>
                </v-sheet>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import backgroundParallax from '@/components/widgets/background-parallax';
import activeRequestTab from '@/components/active-request-tab';
import myGarageTab from '@/components/my-garage-tab';

export default {
    name: 'active-requests',
    components: {
        backgroundParallax,
        activeRequestTab,
        myGarageTab,
    },
    data: () => ({
        currentTab: 0,
    }),
    created() {
        if (this.$store.getters['user/isOrganization']) {
            this.$store.dispatch('notifications/loadNotifications');
        }
        else {
            this.currentTab = 1;
        }
        if (this.$route.query.tab) {
            this.currentTab = parseInt(this.$route.query.tab) - 1;
        }
    },
    computed: {
        allTabs() {
            return [
                { key: 0, label: 'Vehicles', show: this.$store.getters['user/isOrganization'] },
                { key: 1, label: 'Pending', show: true },
                { key: 2, label: 'Shared to Nexus', show: this.$store.getters['user/isWeBuyCars'] },
                { key: 3, label: 'Booked / In Progress', show: true },
                { key: 4, label: 'Ready for Collection', show: true },
                { key: 5, label: 'Completed', show: true },
            ];
        },
        visibleTabs() {
            return this.allTabs.filter(t => t.show);
        },
        tabOptions() {
            // for the mobile dropdown
            return this.visibleTabs.map(t => ({ text: t.label, value: t.key }));
        },
        organization() {
            return this.$store.getters['user/getOrganization'];
        },
        organizationBranch() {
            return this.organization.organizationBranches[0];
        },
        containerClass() {
            let css = 'container';
            if (this.$vuetify.breakpoint.xsOnly) {
                css = `${css} px-0`;
            }
            if (this.$store.getters['user/isOrganization']) {
                css = `${css} home-wide`;
            }
            else {
                css = `${css} home`;
            }
            return css;
        },
    },
    watch: {
        currentTab(newVal) {
            history.pushState({}, null, `/active-requests?tab=${newVal + 1}`);
            if (this.$store.getters['user/isOrganization']) {
                this.$store.dispatch('notifications/loadNotifications');
            }
        },
    },
};
</script>

<style scoped>
.active-work-tab-container,
.active-work-tab-container .v-tabs {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
}

div.home-wide.container {
  max-width: 1500px;
}

.zoho-embed-container {
  height: 320px; 
  border-radius: 15px; 
  background-color: #757575;
}

.zoho-embed-frame {
  border: none;
  border-radius: 15px; 
  border: 1px solid #b3b3b3;
}
</style>

<style>
.active-work-tab-container .v-slide-group {
  height: 60px;
  padding: 10px;
}

.active-work-tab-container .v-tab--active {
  border-radius: 15px;
}
</style>
